import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Senior Mobile Application Developer",
          "React Native & Flutter",
          "AI-Assisted Engineering",
          "Android & iOS",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
        wrapperClassName: "hero-role-inner",
        cursorClassName: "hero-role-cursor",
      }}
    />
  );
}

export default Type;
